import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice un cinquième - Calculez un cinquième du nombre";
const DESCRIPTION =
  "Calculatrice un cinquième - Calculez un cinquième du nombre pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "un cinquième un cinquième du nombre, calculatrice un cinquième un cinquième du nombre, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/one-fifth/";
function OneFifth() {
  const [totalAmount, setTotalAmount] = useState("");
  const [oneFifthAmount, setOneFifthAmount] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!totalAmount) {
      setError("Veuillez entrer le montant total");
      setOneFifthAmount("");
      return;
    }
    const amountValue = parseFloat(totalAmount);
    if (isNaN(amountValue) || amountValue <= 0) {
      setError("Veuillez entrer une valeur correcte et positive pour le montant total");
      setOneFifthAmount("");
      return;
    }
    const oneFifth = amountValue / 5;
    setOneFifthAmount(oneFifth.toFixed(2));
    setError("");
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <h2 style={{ fontSize: "18px" }}>Comment calculer un cinquième du montant</h2>
                <p>
                  Pour calculer un cinquième du montant, vous devez entrer le montant total dont vous souhaitez calculer un cinquième. Ensuite, un cinquième du montant sera calculé simplement en divisant le montant total par le nombre 5.
                </p>
                <p>Un cinquième du montant = Montant total / 5</p>
                <p>
                  Vous pouvez utiliser cette calculatrice pour calculer un cinquième du montant basé sur le montant saisi.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div className="ltr">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label me-2" htmlFor="amount">
                          Entrez le montant
                        </label>
                      </b>
                      <input
                        id="amount"
                        type="number"
                        value={totalAmount}
                        onChange={(e) => setTotalAmount(e.target.value)}
                        placeholder="Montant total"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginRight: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-dark">
                      Erreur : {error}
                    </p>
                  )}
                  {oneFifthAmount && (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className=" text-white">Résultat:</h4>
                      <p className="text-white">Un cinquième = {oneFifthAmount}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default OneFifth;
